import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { of, delay } from 'rxjs';
import { MOVIMENTACOES_FIXTURE, REQUERIMENTOS_FIXTURE, CLAROS_FIXTURE } from '../../features/movimentacao/mocks/movimentacao.fixtures';
import { 
  AFASTAMENTO_DASHBOARD_KPIS, AFASTAMENTO_POR_TIPO, AFASTAMENTO_EVOLUCAO_MENSAL,
  AFASTAMENTO_DISTRIBUICAO_UNIDADE, AFASTAMENTO_EFETIVO_DISPONIVEL, AFASTAMENTO_SAUDE_FERIAS,
  AFASTAMENTO_PROXIMOS_VENCIMENTOS, AFASTAMENTO_ALERTAS_CRITICOS, AFASTAMENTO_ULTIMAS_HOMOLOGACOES,
  PCF_KPIS, PCF_TREE, PCF_MATRIX, PCF_CONFLITOS, CALENDARIO_KPIS, CALENDARIO_EVENTOS,
  AFASTAMENTO_TIPOS, AFASTAMENTO_PARAMETROS, AFASTAMENTOS_LISTA
} from '../../features/afastamento/mocks/afastamento.fixtures';
import {
  PAGAMENTO_ESTATISTICAS, PAGAMENTO_EVOLUCAO_FOLHA, PAGAMENTO_DISTRIBUICAO_RUBRICAS,
  PAGAMENTO_IMPACTO_DOMINIOS, PAGAMENTO_ALERTAS_OPERACIONAIS, PAGAMENTO_TIMELINE_EVENTOS,
  PAGAMENTO_LOTES_HISTORICOS, PAGAMENTO_ALERTAS, PAGAMENTO_PARAMETROS, PAGAMENTO_LANCAMENTOS,
  PAGAMENTO_CENARIOS, PAGAMENTO_DIARIAS
} from '../../features/pagamento/mocks/pagamento.fixtures';
import {
  TEMPO_SERVICO_FICHA_DEFAULT, TEMPO_SERVICO_AVERBACOES, TEMPO_SERVICO_TCDF_CATEGORIAS,
  TEMPO_SERVICO_DASHBOARD_POSICAO, TEMPO_SERVICO_DASHBOARD_PROJECOES, TEMPO_SERVICO_MACRO_PROJECAO_DEFAULT
} from '../../features/tempo-servico/mocks/tempo-servico.fixtures';
import { handleOrganizacaoRequest } from '../../features/organizacao/mocks/organizacao.mock-handler';
import { handleBoletimRequest } from '../../features/boletim/mocks/boletim.mock-handler';
import { MEU_PERFIL_MOCK, LISTA_PERFIS_MOCK, PERFIL_DETALHE_MOCK_MAP } from '../../features/banco-talentos/mocks/banco-talentos.fixtures';
import { PESSOAS_LISTA_MOCK, PESSOA_DETALHE_MOCK, PESSOA_DETALHES_MOCK_MAP } from '../../features/cadastro/mocks/cadastro.fixtures';
import { obterLotacaoExibicao } from '../../features/cadastro/utils/pessoa-display.helper';
import { MOCK_DASHBOARD_DEPENDENTES } from '../../features/cadastro/mocks/cadastro-dashboard.fixtures';
import {
  AUDIT_DASHBOARD_MOCK, AUDIT_EVENTS_MOCK, AUDIT_ALERTS_MOCK, POLITICAS_RETENCAO_MOCK, AUDIT_EXPURGO_MOCK
} from '../../features/auditoria/mocks/auditoria.fixtures';
import {
  INSTRUTORES_MOCK, MINHAS_ALOCACOES_MOCK, AVALIACOES_PENDENTES_MOCK, PRODUTIVIDADE_RELATORIO_MOCK, WORKSPACE_KPIS_MOCK, MOCK_TURMAS_CAPACITACAO
} from '../../features/instrutoria/mocks/instrutoria.fixtures';
import {
  MOCK_STATUS_PROPRIO, MOCK_ACOLHIMENTOS, MOCK_PRONTUARIO, MOCK_DASHBOARD
} from '../../features/bem-estar-psicossocial/mocks/bem-estar.fixtures';
import {
  EstadoAcolhimento, IndicadorSemaforo
} from '../../features/bem-estar-psicossocial/models/bem-estar.models';
import { environment } from '@env/environment';
import {
  MOCK_POLICIAIS,
  MOCK_INDICADORES_1BPM,
  MOCK_EFETIVO_AGREGADO_1BPM,
  MOCK_ALERTAS,
  MOCK_DASHBOARD_GLOBAL
} from '../../features/mapa-forca/mocks/mapa-forca.fixtures';



export const mockInterceptor: HttpInterceptorFn = (req, next) => {
  // Se for produção e o mock interceptor não deve rodar, apenas passa pra frente
  if (environment.production) {
    return next(req);
  }

  // Interceptando chamadas de cadastro
  if (req.url.includes('/v1/cadastro/dashboard/dependentes')) {
    console.log('[MockInterceptor] Intercepted /v1/cadastro/dashboard/dependentes request:', req.url);
    return of(new HttpResponse({ status: 200, body: MOCK_DASHBOARD_DEPENDENTES })).pipe(delay(300));
  }

  if (req.url.includes('/v1/cadastro/atualizacao/')) {
    console.log('[MockInterceptor] Intercepted /v1/cadastro/atualizacao request:', req.url);
    const delayMs = 500;
    
    // Find the person ID in the request URL
    const match = req.url.match(/\/v1\/cadastro\/atualizacao\/(cortex|sirc|detran)\/([^\/]+)/);
    const id = match ? match[2] : '1';
    
    // Get the detailed mock matching this ID
    let mockPessoa = PESSOA_DETALHES_MOCK_MAP[id];
    if (!mockPessoa) {
      const resumo = PESSOAS_LISTA_MOCK.find(p => p.id === id);
      if (resumo) {
        mockPessoa = {
          id: resumo.id,
          cpf: resumo.cpf,
          estadoCadastro: resumo.estadoCadastro,
          dadosCortex: {
            cpf: resumo.cpf,
            nomeCompleto: resumo.nomeCompleto,
            nomeMae: 'Ana Maria de Souza',
            dataNascimento: '1985-05-15',
            rgNumero: '1234567',
            rgOrgaoExpedidor: 'SSP/DF',
            rgUf: 'DF',
            rgDataEmissao: '2005-01-01',
            sexo: 'M' as any,
            nacionalidade: 'Brasileira',
            naturalidadeUf: 'DF',
            naturalidadeCidade: 'Brasília'
          },
          vinculos: resumo.vinculos.map(v => ({
            ...v,
            postoGraduacaoInicial: resumo.vinculos[0]?.tipo === 'PM' ? 'Soldado PM' : '—',
            quadroIngresso: resumo.vinculos[0]?.tipo === 'PM' ? 'QPPM' : '—'
          })) as any,
          enderecos: [],
          telefones: [],
          emails: [],
          formacaoAcademica: [],
          documentos: [],
          biometriaColetada: false,
          criadoEm: resumo.criadoEm,
          criadoPor: 'Sistema',
          atualizadoEm: new Date().toISOString(),
          atualizadoPor: 'Sistema'
        };
        PESSOA_DETALHES_MOCK_MAP[id] = mockPessoa;
      } else {
        mockPessoa = PESSOA_DETALHE_MOCK;
      }
    }
    
    mockPessoa.dadosCortexAtualizadoEm = new Date().toISOString();
    mockPessoa.dadosSircAtualizadoEm = new Date().toISOString();
    mockPessoa.dadosDetranAtualizadoEm = new Date().toISOString();

    localStorage.setItem(`sirc-sincronizado-${id}`, 'true');
    
    if (!mockPessoa.dadosSirc) {
      mockPessoa.dadosSirc = {
        estadoCivil: 'CASADO' as any,
        vinculosFamiliares: []
      };
    } else {
      mockPessoa.dadosSirc.estadoCivil = 'CASADO' as any;
    }
    
    mockPessoa.dadosSirc.vinculosFamiliares = [
      { cpf: '23456789012', nome: 'Gabriela de Souza', parentesco: 'CONJUGE' as any },
      { cpf: '34567890123', nome: 'Arthur de Souza', parentesco: 'FILHO' as any },
      { cpf: '45678901234', nome: 'Beatriz de Souza', parentesco: 'FILHO' as any },
      { cpf: '56789012345', nome: 'Lucas de Souza', parentesco: 'FILHO' as any }
    ];

    if (!mockPessoa.enderecos || mockPessoa.enderecos.length === 0) {
      mockPessoa.enderecos = [
        {
          cep: '70070-600',
          pais: 'Brasil',
          uf: 'DF',
          cidade: 'Brasília',
          bairro: 'Asa Sul',
          logradouro: 'SBS Quadra 4 Lote 3',
          complemento: 'Bloco A Apt 502',
          principal: true
        }
      ];
    }

    if (!mockPessoa.telefones || mockPessoa.telefones.length === 0) {
      mockPessoa.telefones = [
        { tipo: 'CELULAR', numero: '(61) 98765-4321', operadora: 'Claro' }
      ];
    }

    if (!mockPessoa.emails || mockPessoa.emails.length === 0) {
      mockPessoa.emails = [
        { tipo: 'PESSOAL', email: 'titular.pmdf@gmail.com' },
        { tipo: 'INSTITUCIONAL', email: 'titular@pm.df.gov.br' }
      ];
    }

    if (!mockPessoa.dadosBancarios) {
      mockPessoa.dadosBancarios = {
        banco: 'Banco de Brasília (BRB)',
        agencia: '0100',
        tipoConta: 'CORRENTE' as any,
        numeroConta: '123456-7'
      };
    }

    mockPessoa.dadosDetran = {
      habilitado: true,
      cnhCategoria: 'AB' as any,
      cnhRegistro: '09876543210'
    };

    return of(new HttpResponse({ status: 200, body: mockPessoa })).pipe(delay(delayMs));
  }

  if (req.url.includes('/v1/cadastro/pessoas') && !req.url.includes('/dependentes')) {
    console.log('[MockInterceptor] Intercepted /v1/cadastro/pessoas request:', req.url);
    const delayMs = 500;

    if (req.method === 'GET' && !req.url.match(/\/v1\/cadastro\/pessoas\/([a-f0-9-]+|1|2|3|4|5)/)) {
      let filtered = [...PESSOAS_LISTA_MOCK];
      const search = req.params.get('nome') || req.params.get('cpf');
      const tipo = req.params.get('tipoVinculo');
      const estado = req.params.get('estadoCadastro');
      const upm = req.params.get('upmCodigo');

      if (search) {
        const query = search.toLowerCase();
        filtered = filtered.filter(p => p.nomeCompleto.toLowerCase().includes(query) || p.cpf.includes(query));
      }
      if (tipo) {
        filtered = filtered.filter(p => p.vinculos?.some(v => v.tipo === tipo));
      }
      if (estado) {
        filtered = filtered.filter(p => p.estadoCadastro === estado);
      }
      if (upm) {
        filtered = filtered.filter(p => {
          const lotacao = obterLotacaoExibicao(p);
          return lotacao.toLowerCase().includes(upm.toLowerCase());
        });
      }

      const pageStr = req.params.get('page') || '0';
      const sizeStr = req.params.get('size') || '20';
      const page = parseInt(pageStr, 10);
      const size = parseInt(sizeStr, 10);

      const total = filtered.length;
      const start = page * size;
      const content = filtered.slice(start, start + size);

      return of(new HttpResponse({
        status: 200,
        body: {
          content,
          totalElements: total,
          totalPages: Math.ceil(total / size),
          page,
          size
        }
      })).pipe(delay(delayMs));
    }

    if (req.method === 'GET') {
      const match = req.url.match(/\/v1\/cadastro\/pessoas\/([^\/]+)/);
      const id = match ? match[1] : '1';
      let body = PESSOA_DETALHES_MOCK_MAP[id];
      if (!body) {
        const resumo = PESSOAS_LISTA_MOCK.find(p => p.id === id);
        if (resumo) {
          body = {
            id: resumo.id,
            cpf: resumo.cpf,
            estadoCadastro: resumo.estadoCadastro,
            dadosCortex: {
              cpf: resumo.cpf,
              nomeCompleto: resumo.nomeCompleto,
              nomeMae: 'Ana Maria de Souza',
              dataNascimento: '1985-05-15',
              rgNumero: '1234567',
              rgOrgaoExpedidor: 'SSP/DF',
              rgUf: 'DF',
              rgDataEmissao: '2005-01-01',
              sexo: 'M' as any,
              nacionalidade: 'Brasileira',
              naturalidadeUf: 'DF',
              naturalidadeCidade: 'Brasília'
            },
            vinculos: resumo.vinculos.map(v => ({
              ...v,
              postoGraduacaoInicial: resumo.vinculos[0]?.tipo === 'PM' ? 'Soldado PM' : '—',
              quadroIngresso: resumo.vinculos[0]?.tipo === 'PM' ? 'QPPM' : '—'
            })) as any,
            enderecos: [],
            telefones: [],
            emails: [],
            formacaoAcademica: [],
            documentos: [],
            biometriaColetada: false,
            criadoEm: resumo.criadoEm,
            criadoPor: 'Sistema',
            atualizadoEm: new Date().toISOString(),
            atualizadoPor: 'Sistema'
          };
          PESSOA_DETALHES_MOCK_MAP[id] = body;
        } else {
          body = PESSOA_DETALHE_MOCK;
        }
      }
      return of(new HttpResponse({ status: 200, body })).pipe(delay(delayMs));
    }

    return of(new HttpResponse({ status: 200, body: PESSOA_DETALHE_MOCK })).pipe(delay(delayMs));
  }

  // Interceptando chamadas de movimentacao
  if (req.url.includes('/v1/movimentacoes')) {
    console.log('[MockInterceptor] Intercepted /v1/movimentacoes request:', req.url);
    
    // Simulate delay
    const delayMs = 500;

    if (req.url.includes('/estatisticas')) {
       return of(new HttpResponse({
          status: 200,
          body: {
             saldoEfetivoPeriodo: 10,
             totalClarosGeral: 10,
             clarosPorOpm: [],
             perfilSexo: [],
             perfilIdade: [],
             distribuicaoHierarquica: [],
             motivosDesligamento: [],
             alertasCriticos: []
          }
       })).pipe(delay(delayMs));
    }

    if (req.url.includes('/claros')) {
       return of(new HttpResponse({
          status: 200,
          body: CLAROS_FIXTURE
       })).pipe(delay(delayMs));
    }

    if (req.url.includes('/requerimentos')) {
       return of(new HttpResponse({
          status: 200,
          body: REQUERIMENTOS_FIXTURE
       })).pipe(delay(delayMs));
    }

    // Default Movimentacoes Search/List
    return of(new HttpResponse({
      status: 200,
      body: {
        content: MOVIMENTACOES_FIXTURE,
        totalElements: MOVIMENTACOES_FIXTURE.length,
        totalPages: 1,
        page: 0,
        size: 20
      }
    })).pipe(delay(delayMs));
  }

  // Interceptando chamadas de afastamento
  if (req.url.includes('/v1/afastamentos')) {
    console.log('[MockInterceptor] Intercepted /v1/afastamentos request:', req.url);
    const delayMs = 500;

    const routeMap: Record<string, any> = {
      '/dashboard/kpis': AFASTAMENTO_DASHBOARD_KPIS,
      '/dashboard/tipos': AFASTAMENTO_POR_TIPO,
      '/dashboard/evolucao': AFASTAMENTO_EVOLUCAO_MENSAL,
      '/dashboard/distribuicao-unidade': AFASTAMENTO_DISTRIBUICAO_UNIDADE,
      '/dashboard/efetivo-disponibilidade': AFASTAMENTO_EFETIVO_DISPONIVEL,
      '/dashboard/saude-ferias-licencas': AFASTAMENTO_SAUDE_FERIAS,
      '/dashboard/proximos-vencimentos': AFASTAMENTO_PROXIMOS_VENCIMENTOS,
      '/dashboard/alertas': AFASTAMENTO_ALERTAS_CRITICOS,
      '/dashboard/ultimas-homologacoes': AFASTAMENTO_ULTIMAS_HOMOLOGACOES,
      '/pcf/kpis': PCF_KPIS,
      '/pcf/tree': PCF_TREE,
      '/pcf/matrix': PCF_MATRIX,
      '/pcf/conflitos': PCF_CONFLITOS,
      '/calendario/kpis': CALENDARIO_KPIS,
      '/calendario/eventos': CALENDARIO_EVENTOS,
      '/tipos': AFASTAMENTO_TIPOS,
      '/parametros': AFASTAMENTO_PARAMETROS,
      '/meus': AFASTAMENTOS_LISTA
    };

    for (const [route, data] of Object.entries(routeMap)) {
      if (req.url.includes(route)) {
        return of(new HttpResponse({ status: 200, body: data })).pipe(delay(delayMs));
      }
    }

    // Listagem default de afastamentos
    return of(new HttpResponse({
      status: 200,
      body: {
        content: AFASTAMENTOS_LISTA,
        totalElements: AFASTAMENTOS_LISTA.length,
        totalPages: 1,
        page: 0,
        size: 20
      }
    })).pipe(delay(delayMs));
  }

  // Interceptando chamadas de pagamento
  if (req.url.includes('/api/v1/pagamento')) {
    console.log('[MockInterceptor] Intercepted /api/v1/pagamento request:', req.url);
    const delayMs = 500;

    const routeMap: Record<string, any> = {
      '/estatisticas': PAGAMENTO_ESTATISTICAS,
      '/evolucao-folha': PAGAMENTO_EVOLUCAO_FOLHA,
      '/distribuicao-rubricas': PAGAMENTO_DISTRIBUICAO_RUBRICAS,
      '/impacto-dominios': PAGAMENTO_IMPACTO_DOMINIOS,
      '/alertas-operacionais': PAGAMENTO_ALERTAS_OPERACIONAIS,
      '/timeline-eventos': PAGAMENTO_TIMELINE_EVENTOS,
      '/lotes-historicos': PAGAMENTO_LOTES_HISTORICOS,
      '/parametros': PAGAMENTO_PARAMETROS,
      '/lancamentos': PAGAMENTO_LANCAMENTOS,
      '/simulacoes': PAGAMENTO_CENARIOS,
      '/diarias/prestacoes-pendentes': PAGAMENTO_DIARIAS.filter(d => d.status === 'PAGA' || d.status === 'EM_ATRASO'),
      '/diarias': PAGAMENTO_DIARIAS,
      '/alertas': PAGAMENTO_ALERTAS
    };

    for (const [route, data] of Object.entries(routeMap)) {
      if (req.url.includes(route)) {
        return of(new HttpResponse({ status: 200, body: data })).pipe(delay(delayMs));
      }
    }

    // Default Pagamentos
    return of(new HttpResponse({ status: 200, body: {} })).pipe(delay(delayMs));
  }

  // Interceptando chamadas de tempo-servico
  if (req.url.includes('/v1/tempo-servico')) {
    console.log('[MockInterceptor] Intercepted /v1/tempo-servico request:', req.url);
    const delayMs = 500;

    // Se for POST de averbação, precisamos lidar para retornar algo, pois o service espera a averbação de volta.
    // E simular e macrosimular... Como o MockInterceptor apenas devolve JSON estático, o ideal é interceptar a URL e devolver a Ficha.
    
    // Tratando rotas de simular e macrosimular:
    if (req.url.includes('/macro-simular')) {
      return of(new HttpResponse({ status: 200, body: { projecaoReal: TEMPO_SERVICO_MACRO_PROJECAO_DEFAULT, projecaoSimulada: TEMPO_SERVICO_MACRO_PROJECAO_DEFAULT, deltas: [], painelDecisao: {} } })).pipe(delay(delayMs));
    }
    
    if (req.url.includes('/simular')) {
      return of(new HttpResponse({ status: 200, body: { cenarioReal: TEMPO_SERVICO_FICHA_DEFAULT, cenariosSimulados: [] } })).pipe(delay(delayMs));
    }

    if (req.url.includes('/dashboard/posicao-atual')) {
      return of(new HttpResponse({ status: 200, body: TEMPO_SERVICO_DASHBOARD_POSICAO })).pipe(delay(delayMs));
    }

    if (req.url.includes('/dashboard/projecoes')) {
      return of(new HttpResponse({ status: 200, body: TEMPO_SERVICO_DASHBOARD_PROJECOES })).pipe(delay(delayMs));
    }

    if (req.url.includes('/averbacoes')) {
      // Retorna uma averbação mockada ao criar/aprovar/rejeitar
      return of(new HttpResponse({ status: 200, body: TEMPO_SERVICO_AVERBACOES[0] })).pipe(delay(delayMs));
    }

    if (req.url.includes('/ficha/')) {
      return of(new HttpResponse({ status: 200, body: TEMPO_SERVICO_FICHA_DEFAULT })).pipe(delay(delayMs));
    }

    return of(new HttpResponse({ status: 200, body: {} })).pipe(delay(delayMs));
  }

  const boletimResponse = handleBoletimRequest(req);
  if (boletimResponse) {
    return boletimResponse;
  }

  // Interceptando chamadas de organizacao
  if (req.url.includes('/v1/organizacao') || req.url.includes('estado-maior.rs.pm.df.gov.br/upm')) {
    console.log('[MockInterceptor] Intercepted organizacao request:', req.url);
    const delayMs = 500;
    return handleOrganizacaoRequest(req, delayMs);
  }

  // Interceptando chamadas de banco-talentos
  if (req.url.includes('/v1/banco-talentos')) {
    console.log('[MockInterceptor] Intercepted /v1/banco-talentos request:', req.url, req.method);
    const delayMs = 300;

    // GET /perfil/me
    if (req.url.includes('/perfil/me') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: MEU_PERFIL_MOCK })).pipe(delay(delayMs));
    }

    // PUT /perfil/me/idiomas
    if (req.url.includes('/perfil/me/idiomas') && req.method === 'PUT') {
      const idiomasInput = req.body as any[];
      const idiomas = idiomasInput.map((idioma, i) => ({
        id: `idioma-${i + 1}`,
        ...idioma
      }));
      MEU_PERFIL_MOCK.idiomas = idiomas;
      return of(new HttpResponse({ status: 200, body: idiomas })).pipe(delay(delayMs));
    }

    // PUT /perfil/me/habilidades
    if (req.url.includes('/perfil/me/habilidades') && req.method === 'PUT') {
      const habilidadesInput = req.body as any[];
      const habilidades = habilidadesInput.map((habilidade, i) => ({
        id: `habilidade-${i + 1}`,
        ...habilidade
      }));
      MEU_PERFIL_MOCK.habilidades = habilidades;
      return of(new HttpResponse({ status: 200, body: habilidades })).pipe(delay(delayMs));
    }

    // PUT /perfil/me/experiencias
    if (req.url.includes('/perfil/me/experiencias') && req.method === 'PUT') {
      const experienciasInput = req.body as any[];
      const experiencias = experienciasInput.map((experiencia, i) => ({
        id: `experiencia-${i + 1}`,
        ...experiencia
      }));
      MEU_PERFIL_MOCK.experiencias = experiencias;
      return of(new HttpResponse({ status: 200, body: experiencias })).pipe(delay(delayMs));
    }

    // PUT /perfil/me/certificacoes
    if (req.url.includes('/perfil/me/certificacoes') && req.method === 'PUT') {
      const certificacoesInput = req.body as any[];
      const certificacoes = certificacoesInput.map((certificacao, i) => ({
        id: `certificacao-${i + 1}`,
        ...certificacao
      }));
      MEU_PERFIL_MOCK.certificacoes = certificacoes;
      return of(new HttpResponse({ status: 200, body: certificacoes })).pipe(delay(delayMs));
    }

    // PUT /perfil/me/interesses
    if (req.url.includes('/perfil/me/interesses') && req.method === 'PUT') {
      const interesses = req.body as any[];
      MEU_PERFIL_MOCK.interesses = interesses;
      return of(new HttpResponse({ status: 200, body: interesses })).pipe(delay(delayMs));
    }

    // POST /perfil/me/documentos
    if (req.url.includes('/perfil/me/documentos') && req.method === 'POST') {
      const file = (req.body as FormData).get('file') as File;
      const response = {
        id: 'doc-' + Math.random().toString(36).substr(2, 9),
        nomeArquivo: file ? file.name : 'comprovante.pdf',
        contentType: file ? file.type : 'application/pdf',
        tamanho: file ? file.size : 1024,
        comprovanteUrl: 'https://storage.sgp.pmdf.df.gov.br/banco-talentos/comprovantes/' + (file ? file.name : 'comprovante.pdf')
      };
      return of(new HttpResponse({ status: 201, body: response })).pipe(delay(delayMs));
    }

    // GET /servidores/{id}
    const matchDetail = req.url.match(/\/servidores\/([a-f0-9-]+)/i);
    if (matchDetail && req.method === 'GET') {
      const id = matchDetail[1];
      const perfil = PERFIL_DETALHE_MOCK_MAP[id] || MEU_PERFIL_MOCK;
      return of(new HttpResponse({ status: 200, body: perfil })).pipe(delay(delayMs));
    }

    // GET /servidores (busca)
    if (req.url.includes('/servidores') && req.method === 'GET') {
      const idiomaParam = req.params.get('idioma');
      const habilidadeParam = req.params.get('habilidade');

      let content = [...LISTA_PERFIS_MOCK];

      if (idiomaParam) {
        content = content.filter(item => item.habilidadesRelevantes.some(h => h.toLowerCase().includes(idiomaParam.toLowerCase())));
      }
      if (habilidadeParam) {
        content = content.filter(item => item.habilidadesRelevantes.some(h => h.toLowerCase().includes(habilidadeParam.toLowerCase())));
      }

      return of(new HttpResponse({
        status: 200,
        body: {
          content,
          totalElements: content.length,
          totalPages: 1,
          page: 0,
          size: 20
        }
      })).pipe(delay(delayMs));
    }
  }

  // Interceptando chamadas de auditoria e LGPD
  if (req.url.includes('/api/v1/audit')) {
    console.log('[MockInterceptor] Intercepted /api/v1/audit request:', req.url, req.method);
    const delayMs = 400;

    // GET /api/v1/audit/dashboard
    if (req.url.includes('/audit/dashboard') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: AUDIT_DASHBOARD_MOCK })).pipe(delay(delayMs));
    }

    // GET /api/v1/audit/events/{id} (must match before list /events)
    const matchEventDetail = req.url.match(/\/audit\/events\/([a-f0-9-]+)/i);
    if (matchEventDetail && req.method === 'GET') {
      const id = matchEventDetail[1];
      const event = AUDIT_EVENTS_MOCK.find(e => e.id === id) || AUDIT_EVENTS_MOCK[0];
      return of(new HttpResponse({ status: 200, body: event })).pipe(delay(delayMs));
    }

    // GET /api/v1/audit/events
    if (req.url.includes('/audit/events') && req.method === 'GET') {
      const pageStr = req.params.get('page') || '0';
      const sizeStr = req.params.get('size') || '20';
      const page = parseInt(pageStr, 10);
      const size = parseInt(sizeStr, 10);
      
      const domainParam = req.params.get('domain');
      const actionParam = req.params.get('action');
      const matriculaParam = req.params.get('matricula');
      const resourceParam = req.params.get('resource');

      let filteredList = [...AUDIT_EVENTS_MOCK];
      if (domainParam) {
        filteredList = filteredList.filter(e => e.domain === domainParam);
      }
      if (actionParam) {
        filteredList = filteredList.filter(e => e.action === actionParam);
      }
      if (matriculaParam) {
        filteredList = filteredList.filter(e => e.matricula.toLowerCase().includes(matriculaParam.toLowerCase()));
      }
      if (resourceParam) {
        filteredList = filteredList.filter(e => e.resource.toLowerCase().includes(resourceParam.toLowerCase()));
      }

      const total = filteredList.length;
      const start = page * size;
      const content = filteredList.slice(start, start + size);

      return of(new HttpResponse({
        status: 200,
        body: {
          content,
          totalElements: total,
          totalPages: Math.ceil(total / size),
          page,
          size
        }
      })).pipe(delay(delayMs));
    }

    // POST /api/v1/audit/events (registrar batch)
    if (req.url.includes('/audit/events') && req.method === 'POST') {
      return of(new HttpResponse({ status: 202, body: null })).pipe(delay(delayMs));
    }

    // POST /api/v1/audit/export
    if (req.url.includes('/audit/export') && req.method === 'POST') {
      const format = (req.body as any)?.format || 'PDF';
      const content = format === 'PDF' 
        ? '%PDF-1.4 ... (Assinado Digitalmente pelo SGP-PMDF)' 
        : 'id,action,domain,resource,timestamp,matricula,ip\n1,VIEW,saude,ficha-medica,2026-06-15T10:00:15Z,912.854-C,10.112.4.52';
      const blob = new Blob([content], { type: format === 'PDF' ? 'application/pdf' : 'text/csv' });
      return of(new HttpResponse({ status: 200, body: blob })).pipe(delay(delayMs));
    }

    // POST /api/v1/audit/alertas/{id}/resolve (simular resolução)
    const matchAlertResolve = req.url.match(/\/audit\/alertas\/([a-f0-9-]+)\/resolve/i);
    if (matchAlertResolve && req.method === 'POST') {
      const id = matchAlertResolve[1];
      const alert = AUDIT_ALERTS_MOCK.find(a => a.id === id);
      if (alert) {
        alert.resolved = true;
        alert.resolvedBy = '990.221-X';
        alert.resolvedAt = new Date().toISOString();
      }
      return of(new HttpResponse({ status: 200, body: alert || { id, resolved: true } })).pipe(delay(delayMs));
    }

    // GET /api/v1/audit/alertas
    if (req.url.includes('/audit/alertas') && req.method === 'GET') {
      const pageStr = req.params.get('page') || '0';
      const sizeStr = req.params.get('size') || '20';
      const resolvedParam = req.params.get('resolved');
      
      const page = parseInt(pageStr, 10);
      const size = parseInt(sizeStr, 10);
      
      let filtered = [...AUDIT_ALERTS_MOCK];
      if (resolvedParam !== null && resolvedParam !== undefined && resolvedParam !== '') {
        const isResolved = resolvedParam === 'true';
        filtered = filtered.filter(a => a.resolved === isResolved);
      }

      const total = filtered.length;
      const start = page * size;
      const content = filtered.slice(start, start + size);

      return of(new HttpResponse({
        status: 200,
        body: {
          content,
          totalElements: total,
          totalPages: Math.ceil(total / size),
          page,
          size
        }
      })).pipe(delay(delayMs));
    }

    // GET /api/v1/audit/admin/politicas-retencao
    if (req.url.includes('/audit/admin/politicas-retencao') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: POLITICAS_RETENCAO_MOCK })).pipe(delay(delayMs));
    }

    // POST /api/v1/audit/admin/expurgo
    if (req.url.includes('/audit/admin/expurgo') && req.method === 'POST') {
      return of(new HttpResponse({ status: 200, body: AUDIT_EXPURGO_MOCK })).pipe(delay(delayMs));
    }
  }

  // Interceptando chamadas de instrutoria
  if (req.url.includes('/api/v1/instrutoria') || req.url.includes('/v1/instrutoria')) {
    console.log('[MockInterceptor] Intercepted /v1/instrutoria request:', req.url, req.method);
    const delayMs = 400;

    // GET /instrutoria/instrutores/me/turmas
    if (req.url.includes('/instrutores/me/turmas') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: MINHAS_ALOCACOES_MOCK })).pipe(delay(delayMs));
    }

    // GET /instrutoria/avaliacoes/pendentes
    if (req.url.includes('/avaliacoes/pendentes') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: AVALIACOES_PENDENTES_MOCK })).pipe(delay(delayMs));
    }

    // GET /instrutoria/relatorios/produtividade
    if (req.url.includes('/relatorios/produtividade') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: PRODUTIVIDADE_RELATORIO_MOCK })).pipe(delay(delayMs));
    }

    // GET /instrutoria/workspace (Para KPIs consolidadores e charts)
    if (req.url.includes('/workspace') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: WORKSPACE_KPIS_MOCK })).pipe(delay(delayMs));
    }

    // GET /instrutoria/instrutores/{id}
    const matchId = req.url.match(/\/instrutores\/([a-f0-9-]+)$/i);
    if (matchId && req.method === 'GET') {
      const id = matchId[1];
      const instrutor = INSTRUTORES_MOCK.find(i => i.id === id) || INSTRUTORES_MOCK[0];
      return of(new HttpResponse({ status: 200, body: instrutor })).pipe(delay(delayMs));
    }

    // PATCH /instrutoria/instrutores/{id}/suspender
    if (req.url.includes('/suspender') && req.method === 'PATCH') {
      const parts = req.url.split('/');
      const id = parts[parts.length - 2];
      const instrutor = INSTRUTORES_MOCK.find(i => i.id === id);
      if (instrutor) {
        instrutor.estado = 'SUSPENSO';
      }
      return of(new HttpResponse({ status: 200, body: instrutor || INSTRUTORES_MOCK[0] })).pipe(delay(delayMs));
    }

    // GET /instrutoria/instrutores
    if (req.url.includes('/instrutores') && req.method === 'GET') {
      const pageStr = req.params.get('page') || '0';
      const sizeStr = req.params.get('size') || '20';
      const area = req.params.get('areaInstrucao');
      const ativo = req.params.get('ativo');

      const page = parseInt(pageStr, 10);
      const size = parseInt(sizeStr, 10);

      let filtered = [...INSTRUTORES_MOCK];
      if (area) {
        filtered = filtered.filter(i => i.habilitacoes.some(h => h.areaInstrucao.toLowerCase().includes(area.toLowerCase())));
      }
      if (ativo !== null && ativo !== undefined && ativo !== '') {
        const isAtivo = ativo === 'true';
        filtered = filtered.filter(i => isAtivo ? i.estado === 'ATIVO' : i.estado === 'SUSPENSO');
      }

      const total = filtered.length;
      const start = page * size;
      const content = filtered.slice(start, start + size);

      return of(new HttpResponse({
        status: 200,
        body: {
          content,
          totalElements: total,
          totalPages: Math.ceil(total / size),
          page,
          size
        }
      })).pipe(delay(delayMs));
    }

    // POST /instrutoria/turmas/{id}/alocar
    if (req.url.includes('/alocar') && req.method === 'POST') {
      const parts = req.url.split('/');
      const turmaId = parts[parts.length - 2];
      const body = req.body as any;
      const instrutorId = body.instrutorId;
      const disciplina = body.disciplina;

      const instrutor = INSTRUTORES_MOCK.find(i => i.id === instrutorId);
      if (instrutor && instrutor.estado === 'SUSPENSO') {
        // Retorna erro 422 conforme regra de negócio RN-INST-003
        return of(new HttpResponse({
          status: 422,
          statusText: 'Unprocessable Entity',
          headers: req.headers,
          body: {
            type: 'https://sgp.pmdf.df.gov.br/problems/validation-error',
            title: 'Instrutor Suspenso',
            status: 422,
            detail: `O instrutor ${instrutor.nomeCompleto} está suspenso e não pode ser alocado.`
          }
        })).pipe(delay(delayMs));
      }

      const alocacao = {
        id: 'aloc-' + Math.random().toString(36).substr(2, 9),
        instrutorId,
        turmaId,
        disciplina,
        alocadoEm: new Date().toISOString()
      };
      return of(new HttpResponse({ status: 201, body: alocacao })).pipe(delay(delayMs));
    }

    // POST /instrutoria/cargas-horarias
    if (req.url.includes('/cargas-horarias') && req.method === 'POST') {
      const body = req.body as any;
      
      // Validação RN-INST-004: max 12 horas diárias
      if (body.horas > 12) {
        return of(new HttpResponse({
          status: 400,
          statusText: 'Bad Request',
          body: {
            type: 'https://sgp.pmdf.df.gov.br/problems/validation-error',
            title: 'Erro de validação',
            status: 400,
            detail: 'Carga horária excede o limite máximo permitido de 12 horas diárias.'
          }
        })).pipe(delay(delayMs));
      }

      // Validação de data posterior
      const dataAula = new Date(body.dataAula);
      const hoje = new Date();
      hoje.setHours(23, 59, 59, 999);
      if (dataAula > hoje) {
        return of(new HttpResponse({
          status: 400,
          statusText: 'Bad Request',
          body: {
            type: 'https://sgp.pmdf.df.gov.br/problems/validation-error',
            title: 'Erro de validação',
            status: 400,
            detail: 'A data da aula não pode ser uma data futura.'
          }
        })).pipe(delay(delayMs));
      }

      const cargaHoraria = {
        id: 'carga-' + Math.random().toString(36).substr(2, 9),
        instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47001', // Cap. João logado
        turmaId: body.turmaId,
        disciplina: body.disciplina,
        dataAula: body.dataAula,
        horas: body.horas,
        observacoes: body.observacoes || null,
        registradoEm: new Date().toISOString()
      };
      return of(new HttpResponse({ status: 201, body: cargaHoraria })).pipe(delay(delayMs));
    }

    // POST /instrutoria/avaliacoes
    if (req.url.includes('/avaliacoes') && req.method === 'POST') {
      return of(new HttpResponse({ status: 201, body: null })).pipe(delay(delayMs));
    }

    // GET /instrutoria/turmas-capacitacao (Adicional para listagem do outro domínio na UI de alocação)
    if (req.url.includes('/turmas-capacitacao') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: MOCK_TURMAS_CAPACITACAO })).pipe(delay(delayMs));
    }
  }

  // Interceptando chamadas de bem-estar-psicossocial
  if (req.url.includes('/api/v1/bem-estar')) {
    console.log('[MockInterceptor] Intercepted /api/v1/bem-estar request:', req.url, req.method);
    const delayMs = 400;

    // GET /bem-estar/servidores/me/status
    if (req.url.includes('/servidores/me/status') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: MOCK_STATUS_PROPRIO })).pipe(delay(delayMs));
    }

    // GET /bem-estar/dashboard/unidades/
    if (req.url.includes('/dashboard/unidades/') && req.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: MOCK_DASHBOARD })).pipe(delay(delayMs));
    }

    // GET /bem-estar/servidores/{id}/indicadores
    const matchIndicadores = req.url.match(/\/servidores\/([a-f0-9-]+)\/indicadores/i);
    if (matchIndicadores && req.method === 'GET') {
      const servidorId = matchIndicadores[1];
      const res = {
        servidorId,
        indicadorPsicologico: 'ATIVO_MONITORADO' as IndicadorSemaforo,
        validadePsicologico: '2026-12-01',
        indicadorSocial: 'ATIVO_BEM' as IndicadorSemaforo,
        validadeSocial: '2026-12-01',
        atualizadoEm: new Date().toISOString()
      };
      return of(new HttpResponse({ status: 200, body: res })).pipe(delay(delayMs));
    }

    // POST /bem-estar/acolhimentos/{id}/sessoes
    const matchSessao = req.url.match(/\/acolhimentos\/([a-f0-9-]+)\/sessoes/i);
    if (matchSessao && req.method === 'POST') {
      const acolhimentoId = matchSessao[1];
      const body = req.body as any;
      const novaSessao = {
        id: 'sess-' + Math.random().toString(36).substr(2, 9),
        acolhimentoId,
        dataSessao: body.dataSessao || new Date().toISOString(),
        tipo: body.tipo || 'INDIVIDUAL',
        registro: body.registro || '',
        profissionalId: '7ccbc8cb-456c-48b2-11ee-33881dfdcc12'
      };
      MOCK_PRONTUARIO.sessoes.unshift(novaSessao);
      return of(new HttpResponse({ status: 200, body: novaSessao })).pipe(delay(delayMs));
    }

    // PUT /bem-estar/acolhimentos/{id}/plano
    const matchPlano = req.url.match(/\/acolhimentos\/([a-f0-9-]+)\/plano/i);
    if (matchPlano && req.method === 'PUT') {
      const acolhimentoId = matchPlano[1];
      const body = req.body as any;
      const planoAtualizado = {
        id: MOCK_PRONTUARIO.plano?.id || 'plano-' + Math.random().toString(36).substr(2, 9),
        acolhimentoId,
        objetivos: body.objetivos,
        periodicidade: body.periodicidade,
        dataInicio: MOCK_PRONTUARIO.plano?.dataInicio || new Date().toISOString().substring(0, 10),
        dataRevisao: body.dataRevisao
      };
      MOCK_PRONTUARIO.plano = planoAtualizado;
      return of(new HttpResponse({ status: 200, body: planoAtualizado })).pipe(delay(delayMs));
    }

    // PATCH /bem-estar/acolhimentos/{id}/indicador
    const matchIndicadorPatch = req.url.match(/\/acolhimentos\/([a-f0-9-]+)\/indicador/i);
    if (matchIndicadorPatch && req.method === 'PATCH') {
      const acolhimentoId = matchIndicadorPatch[1];
      const body = req.body as any;
      const ac = MOCK_ACOLHIMENTOS.find(a => a.id === acolhimentoId) || MOCK_PRONTUARIO.acolhimento;
      if (ac) {
        if (body.eixo === 'PSICOLOGICO') {
          ac.indicadorPsicologicoAtual = body.indicador;
        } else if (body.eixo === 'SOCIAL') {
          ac.indicadorSocialAtual = body.indicador;
        }
      }
      return of(new HttpResponse({ status: 200, body: ac })).pipe(delay(delayMs));
    }

    // POST /bem-estar/acolhimentos/{id}/alta
    const matchAlta = req.url.match(/\/acolhimentos\/([a-f0-9-]+)\/alta/i);
    if (matchAlta && req.method === 'POST') {
      const acolhimentoId = matchAlta[1];
      const body = req.body as any;
      const ac = MOCK_ACOLHIMENTOS.find(a => a.id === acolhimentoId) || MOCK_PRONTUARIO.acolhimento;
      if (ac) {
        ac.estado = 'ALTA';
        ac.altaEm = new Date().toISOString();
        ac.indicadorPsicologicoAtual = body.indicadorSemaforoFinal;
        ac.indicadorSocialAtual = body.indicadorSemaforoFinal;
      }
      return of(new HttpResponse({ status: 200, body: ac })).pipe(delay(delayMs));
    }

    // GET /bem-estar/acolhimentos/{id}
    const matchProntuarioDetail = req.url.match(/\/acolhimentos\/([a-f0-9-]+)$/i);
    if (matchProntuarioDetail && req.method === 'GET') {
      const id = matchProntuarioDetail[1];
      const acolhimento = MOCK_ACOLHIMENTOS.find(a => a.id === id) || MOCK_PRONTUARIO.acolhimento;
      const res = {
        ...MOCK_PRONTUARIO,
        acolhimento
      };
      return of(new HttpResponse({ status: 200, body: res })).pipe(delay(delayMs));
    }

    // GET /bem-estar/acolhimentos (lista/fila)
    if (req.url.includes('/acolhimentos') && req.method === 'GET') {
      const pageStr = req.params.get('page') || '0';
      const sizeStr = req.params.get('size') || '20';
      const estado = req.params.get('estado');
      const page = parseInt(pageStr, 10);
      const size = parseInt(sizeStr, 10);

      let filtered = [...MOCK_ACOLHIMENTOS];
      if (estado) {
        filtered = filtered.filter(a => a.estado === estado);
      }

      const total = filtered.length;
      const start = page * size;
      const content = filtered.slice(start, start + size);

      return of(new HttpResponse({
        status: 200,
        body: {
          content,
          totalElements: total,
          totalPages: Math.ceil(total / size),
          page,
          size
        }
      })).pipe(delay(delayMs));
    }

    // POST /bem-estar/acolhimentos (criar acolhimento)
    if (req.url.includes('/acolhimentos') && req.method === 'POST') {
      const body = req.body as any;
      
      let servidorId = body.servidorId;
      let nomeServidor = 'PM MOCK SERVIDOR ADICIONADO';
      let matricula = '999.888-7';

      if (body.cpf) {
        const cpfDigitado = body.cpf.replace(/\D/g, '');
        const cpfMap: Record<string, { id: string; nome: string; matricula: string }> = {
          '11122233344': {
            id: 'a63b0a21-1773-45d2-a7cc-22bd1f2bc88b',
            nome: 'SGT PM THIAGO RAMOS SILVA',
            matricula: '819.043-4',
          },
          '22233344455': {
            id: 'b74c1b32-2884-56e3-b8dd-33ce2g3cd99c',
            nome: 'CB PM ALINE CRISTINA MOREIRA',
            matricula: '921.034-5',
          },
          '33344455566': {
            id: 'c85d2c43-3995-67f4-c9ee-44df3h4de00d',
            nome: 'SD PM CARLOS HENRIQUE NEVES',
            matricula: '934.112-0',
          },
          '44455566677': {
            id: 'd96e3d54-4006-78g5-d0ff-55eg4i5ef11e',
            nome: 'SGT PM JULIANA FERREIRA LIMA',
            matricula: '741.092-1',
          },
        };

        const servidorEncontrado = cpfMap[cpfDigitado];
        if (servidorEncontrado) {
          servidorId = servidorEncontrado.id;
          nomeServidor = servidorEncontrado.nome;
          matricula = servidorEncontrado.matricula;
        } else {
          servidorId = 'servidor-' + Math.random().toString(36).substr(2, 9);
          nomeServidor = 'PM DE TESTE CPF ' + cpfDigitado;
          matricula = '123.456-' + Math.floor(Math.random() * 9);
        }
      }

      const isProprio = servidorId === MOCK_STATUS_PROPRIO.servidorId;

      if (isProprio) {
        MOCK_STATUS_PROPRIO.status = 'EM_TRIAGEM';
        nomeServidor = 'SGT PM THIAGO RAMOS SILVA';
        matricula = '819.043-4';
      }

      const novo = {
        id: 'acolhimento-' + Math.random().toString(36).substr(2, 9),
        servidorId: servidorId || 'a63b0a21-1773-45d2-a7cc-22bd1f2bc88b',
        nomeServidor,
        matricula,
        tipo: body.tipo,
        estado: 'TRIAGEM' as EstadoAcolhimento,
        profissionalResponsavelId: null,
        consentimentoRegistrado: false,
        consentimentoData: null,
        indicadorPsicologicoAtual: 'ATIVO_BEM' as IndicadorSemaforo,
        indicadorSocialAtual: 'ATIVO_BEM' as IndicadorSemaforo,
        indicadorValidade: null,
        criadoEm: new Date().toISOString(),
        altaEm: null
      };
      MOCK_ACOLHIMENTOS.unshift(novo);
      return of(new HttpResponse({ status: 200, body: novo })).pipe(delay(delayMs));
    }
  }

  // Interceptando chamadas de mapa-forca
  if (req.url.includes('/api/v1/mapa-forca') || req.url.includes('/v1/mapa-forca')) {
    console.log('[MockInterceptor] Intercepted mapa-forca request:', req.url, req.method);
    const delayMs = 300;

    // GET /api/v1/mapa-forca/dashboard/comando-geral
    if (req.url.includes('/dashboard/comando-geral')) {
      return of(new HttpResponse({ status: 200, body: MOCK_DASHBOARD_GLOBAL })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/unidades/{idUnidade}/efetivo/policiais/{matricula}
    const matchPolicialDetail = req.url.match(/\/unidades\/[A-Za-z0-9-]+\/efetivo\/policiais\/([0-9.]+)/i);
    if (matchPolicialDetail && req.method === 'GET') {
      const matricula = matchPolicialDetail[1];
      const policial = MOCK_POLICIAIS.find(p => p.matricula === matricula) || MOCK_POLICIAIS[0];
      return of(new HttpResponse({ status: 200, body: policial })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/unidades/{idUnidade}/efetivo
    if (req.url.includes('/efetivo') && req.url.includes('/unidades/')) {
      return of(new HttpResponse({
        status: 200,
        body: MOCK_EFETIVO_AGREGADO_1BPM
      })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/unidades/{idUnidade}/indicadores
    if (req.url.includes('/indicadores') && req.url.includes('/unidades/')) {
      return of(new HttpResponse({ status: 200, body: MOCK_INDICADORES_1BPM })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/unidades/{idUnidade}/restricoes
    if (req.url.includes('/restricoes') && req.url.includes('/unidades/')) {
      const restricoes = MOCK_POLICIAIS.filter(p => p.situacoesAtivas.length > 0).map(p => ({
        matricula: p.matricula,
        nomeGuerra: p.nomeGuerra,
        situacao: p.situacoesAtivas[0]
      }));
      return of(new HttpResponse({
        status: 200,
        body: {
          restricoes,
          restricoesProximasVencimento: 2
        }
      })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/efetivo (Global List)
    if (req.url.endsWith('/efetivo') && req.method === 'GET') {
      const pageStr = req.params.get('page') || '0';
      const sizeStr = req.params.get('size') || '20';
      const page = parseInt(pageStr, 10);
      const size = parseInt(sizeStr, 10);

      let filtered = [...MOCK_POLICIAIS];
      const unidadeParam = req.params.get('idUnidade');
      if (unidadeParam) {
        filtered = filtered.filter(p => p.idUnidade === unidadeParam);
      }
      const disponibilidadeParam = req.params.get('disponibilidade');
      if (disponibilidadeParam) {
        filtered = filtered.filter(p => p.disponibilidadeOperacional === disponibilidadeParam);
      }

      const total = filtered.length;
      const start = page * size;
      const content = filtered.slice(start, start + size);

      return of(new HttpResponse({
        status: 200,
        body: {
          content,
          totalElements: total,
          totalPages: Math.ceil(total / size),
          page,
          size
        }
      })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/efetivo/export
    if (req.url.includes('/efetivo/export')) {
      const csvContent = 'matricula,nomeGuerra,postoGraduacao,quadroCarreira,unidade,disponibilidadeOperacional\n' +
        MOCK_POLICIAIS.map(p => `${p.matricula},${p.nomeGuerra},${p.postoGraduacao},${p.quadroCarreira},${p.nomeUnidade},${p.disponibilidadeOperacional}`).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv' });
      return of(new HttpResponse({ status: 200, body: blob })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/alertas
    if (req.url.includes('/alertas')) {
      return of(new HttpResponse({ status: 200, body: MOCK_ALERTAS })).pipe(delay(delayMs));
    }

    // GET /api/v1/mapa-forca/busca-capacidade
    if (req.url.includes('/busca-capacidade')) {
      const habilitacaoParam = req.params.get('codigosHabilitacao') || '';
      const codigos = habilitacaoParam.split(',').filter(c => c);

      let filtered = [...MOCK_POLICIAIS];
      if (codigos.length > 0) {
        filtered = filtered.filter(p => 
          codigos.every(cod => p.habilitacoes.some(h => h.codigoCurso === cod))
        );
      }

      const isDisponivelOnly = req.params.get('apenasDisponiveis') === 'true';
      if (isDisponivelOnly) {
        filtered = filtered.filter(p => p.disponibilidadeOperacional === 'DISPONIVEL_OPERACIONAL');
      }

      return of(new HttpResponse({
        status: 200,
        body: {
          content: filtered,
          totalElements: filtered.length,
          dataReferencia: new Date().toISOString()
        }
      })).pipe(delay(delayMs));
    }

    // Default
    return of(new HttpResponse({ status: 200, body: {} })).pipe(delay(delayMs));
  }

  // Interceptando chamadas de perfil do usuário (SGP)
  if (req.url.includes('/api/v1/user/profile') || req.url.includes('/user/profile')) {
    console.log('[MockInterceptor] Intercepted SGP /api/v1/user/profile request:', req.url);
    const delayMs = 300;
    const body = {
      matricula: '123456',
      cpf: '11122233344',
      dadosSgpol: {
        id: 1,
        cpf: '11122233344',
        nome: 'João Silva Policial',
        subunidade: '1º Batalhão',
        quadro: 'QPPM',
        funcao: 'Comandante de Equipe',
        classificacao: 'Excelente',
        endereco: 'Área Especial nº 4, Setor Policial Sul, Brasília - DF',
        upm: '1º BPM',
        matricula: '123456',
        posto: 'Capitão',
        emails: 'joao.silva@pm.df.gov.br / joao.silva.policial@gmail.com',
        telefones: '(61) 99999-9999 / (61) 3333-3333',
        nomeDeGuerra: 'JOÃO SILVA',
        ativa: true,
        codigoUpm: 1
      },
      fotoBase64: 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    };
    return of(new HttpResponse({ status: 200, body })).pipe(delay(delayMs));
  }

  // Mock das chamadas do Keycloak (Auth/OIDC) — APENAS quando explicitamente habilitado
  // via environment.features.mockAuth (dev local sem Keycloak disponível).
  // NUNCA habilitar em ambientes com Keycloak real (dsv/hml/prod): interceptar o token
  // endpoint impede a conclusão do code flow e trava o login no /auth/callback.
  if (
    environment.features.mockAuth &&
    (req.url.includes('/.well-known/openid-configuration') || req.url.includes('/protocol/openid-connect'))
  ) {
    console.log('[MockInterceptor] Intercepted Keycloak request:', req.url);
    const delayMs = 50;
    
    if (req.url.includes('/openid-configuration')) {
      const body = {
        issuer: req.url.split('/.well-known')[0],
        authorization_endpoint: req.url.replace('/.well-known/openid-configuration', '/protocol/openid-connect/auth'),
        token_endpoint: req.url.replace('/.well-known/openid-configuration', '/protocol/openid-connect/token'),
        userinfo_endpoint: req.url.replace('/.well-known/openid-configuration', '/protocol/openid-connect/userinfo'),
        end_session_endpoint: req.url.replace('/.well-known/openid-configuration', '/protocol/openid-connect/logout'),
        jwks_uri: req.url.replace('/.well-known/openid-configuration', '/protocol/openid-connect/certs'),
        grant_types_supported: ["authorization_code", "implicit", "refresh_token", "password", "client_credentials"],
        response_types_supported: ["code", "none", "id_token", "token", "id_token token", "code id_token", "code token", "code id_token token"],
        subject_types_supported: ["public", "pairwise"],
        id_token_signing_alg_values_supported: ["RS256"]
      };
      return of(new HttpResponse({ status: 200, body })).pipe(delay(delayMs));
    }
    
    if (req.url.includes('/certs')) {
      const body = { keys: [] };
      return of(new HttpResponse({ status: 200, body })).pipe(delay(delayMs));
    }
    
    return of(new HttpResponse({ status: 200, body: {} })).pipe(delay(delayMs));
  }

  // Passa as outras requests (como autenticação) pra frente
  return next(req);
};

